import { emptyString, viewPathConstants } from "../../constants";

//Define module name constants
export const moduleNameConstants = {
  INSTRUCTORS_SCREEN: "INSTRUCTORS_SCREEN",
  USERS_SCREEN: "USERS_SCREEN",
  CENTERS_SCREEN: "CENTERS_SCREEN",
  COURSES_SCREEN: "COURSES_SCREEN",
  EVENTS_SCREEN: "EVENTS_SCREEN",
  COMPETITIONS_SCREEN: "COMPETITIONS_SCREEN",
  SPOTS_SCREEN: "SPOTS_SCREEN",
  SUBSCRIPTION_SETTINGS_SCREEN: "SUBSCRIPTION_SETTINGS_SCREEN",
  ADMIN_USERS_SCREEN: "ADMIN_USERS_SCREEN",
  REFUND_POLICY_SCREEN: "REFUND_POLICY_SCREEN",
  ADMIN_PAYMENT_HISTORY_SCREEN: "ADMIN_PAYMENT_HISTORY_SCREEN",
  ADMIN_AUDIT_LOGS_SCREEN: "ADMIN_AUDIT_LOGS_SCREEN",
  BOAT_CLASSES: "BOAT_CLASSES",
};

// Define admin route constants by extracting from viewPathConstants
export const adminPathConstants = {
  INSTRUCTORS: viewPathConstants.INSTRUCTORS,
  USERS: viewPathConstants.USERS,
  CENTERS: viewPathConstants.CENTERS,
  COURSES: viewPathConstants.COURSES,
  CENTER_PROFILE: viewPathConstants.CENTER_PROFILE,
  EVENTS: viewPathConstants.EVENTS,
  EVENT_FORM: viewPathConstants.EVENTS_FORM,
  EVENT: viewPathConstants.EVENT,
  COMPETITIONS: viewPathConstants.COMPETITIONS,
  VIEW_COMPETITIONS: viewPathConstants.VIEW_COMPETITIONS,
  ADD_COMPETITIONS: viewPathConstants.ADD_COMPETITIONS,
  SPOTS: viewPathConstants.SPOTS,
  SUBSCRIPTION_SETTINGS: viewPathConstants.SUBSCRIPTION_SETTINGS,
  ADMIN_USERS: viewPathConstants.ADMIN_USERS,
  REFUND_POLICY: viewPathConstants.REFUND_POLICY,
  ADMIN_PAYMENT_HISTORY: viewPathConstants.ADMIN_PAYMENT_HISTORY,
  ADMIN_AUDIT_LOGS: viewPathConstants.ADMIN_AUDIT_LOGS,
  BOAT_CLASSES: viewPathConstants.BOAT_CLASSES,
};

// Create an array of admin routes if needed
export const AdminRoutesForServerCalls = [
  adminPathConstants.INSTRUCTORS,
  adminPathConstants.USERS,
  adminPathConstants.CENTERS,
  adminPathConstants.COURSES,
  adminPathConstants.CENTER_PROFILE,
  adminPathConstants.EVENTS,
  adminPathConstants.EVENT_FORM,
  adminPathConstants.EVENT,
  adminPathConstants.COMPETITIONS,
  adminPathConstants.VIEW_COMPETITIONS,
  adminPathConstants.ADD_COMPETITIONS,
  adminPathConstants.SPOTS,
  adminPathConstants.SUBSCRIPTION_SETTINGS,
  adminPathConstants.ADMIN_USERS,
  adminPathConstants.REFUND_POLICY,
  adminPathConstants.ADMIN_PAYMENT_HISTORY,
  adminPathConstants.ADMIN_AUDIT_LOGS,
  adminPathConstants.BOAT_CLASSES,
];

// Define the Enum Object using admin route constants
export const AdminPathEnum = {
  [adminPathConstants.INSTRUCTORS]: moduleNameConstants.INSTRUCTORS_SCREEN,
  [adminPathConstants.USERS]: moduleNameConstants.USERS_SCREEN,
  [adminPathConstants.CENTERS]: moduleNameConstants.CENTERS_SCREEN,
  [adminPathConstants.COURSES]: moduleNameConstants.COURSES_SCREEN,
  [adminPathConstants.CENTER_PROFILE]: moduleNameConstants.CENTERS_SCREEN,
  [adminPathConstants.EVENTS]: moduleNameConstants.EVENTS_SCREEN,
  [adminPathConstants.EVENT_FORM]: moduleNameConstants.EVENTS_SCREEN,
  [adminPathConstants.EVENT]: moduleNameConstants.EVENTS_SCREEN,
  [adminPathConstants.COMPETITIONS]: moduleNameConstants.COMPETITIONS_SCREEN,
  [adminPathConstants.VIEW_COMPETITIONS]:
    moduleNameConstants.COMPETITIONS_SCREEN,
  [adminPathConstants.ADD_COMPETITIONS]:
    moduleNameConstants.COMPETITIONS_SCREEN,
  [adminPathConstants.SPOTS]: moduleNameConstants.SPOTS_SCREEN,
  [adminPathConstants.SUBSCRIPTION_SETTINGS]:
    moduleNameConstants.SUBSCRIPTION_SETTINGS_SCREEN,
  [adminPathConstants.ADMIN_USERS]: moduleNameConstants.ADMIN_USERS_SCREEN,
  [adminPathConstants.REFUND_POLICY]: moduleNameConstants.REFUND_POLICY_SCREEN,
  [adminPathConstants.ADMIN_PAYMENT_HISTORY]:
    moduleNameConstants.ADMIN_PAYMENT_HISTORY_SCREEN,
  [adminPathConstants.ADMIN_AUDIT_LOGS]:
    moduleNameConstants.ADMIN_AUDIT_LOGS_SCREEN,
  [adminPathConstants.BOAT_CLASSES]: moduleNameConstants.BOAT_CLASSES,
};

// Function to get description from path using constants
export function getPathDescription(path) {
  return AdminPathEnum[path] || emptyString;
}
